import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Subscription } from "rxjs/Subscription";
import { MatDialog } from "@angular/material";

import { ResultDialogComponent } from "../result-dialog/result-dialog.component";
import { ReceiptDialogComponent } from "../receipt-dialog/receipt-dialog.component";

import {
  AuthGuardService,
  LoadingService,
  UserService,
  CommercialService,
} from "@core/services";
import { Receipt, User } from "@shared/models";
import { Commercial } from "@shared/models";

import { fadeAnimation } from "../../app.animations";

@Component({
  selector: "app-make-payment",
  templateUrl: "./make-payment.component.html",
  styleUrls: ["./make-payment.component.css"],
  animations: [fadeAnimation],
})
export class MakePaymentComponent implements OnInit {
  makeAPaymentForm: FormGroup;
  subscription: Subscription;
  user: User;
  public isDisabled = false;
  public isApproved = false;
  public isLoadingPaymentHistory: boolean = true;
  public receiptInfo: any;
  public receipt: Receipt = new Receipt();
  public commercial: Commercial;
  public commercialSubscription: Subscription;
  public paymentHistory: any;
  public paymentSubmitted = false;
  public feeArray: any = {};
  public cardId;
  public startDate: any;
  public endDate: any;
  public fees: string;
  public programs: any;
  public defaultReplenishmentAmount: any;
  public initialPaymentFound: boolean = false;
  public isCustomerService: boolean = false;
  referralCode = ""


  private initialModalWidth: string = "50vw";

  constructor(
    private _userService: UserService,
    private _authGuard: AuthGuardService,
    private dialog: MatDialog,
    private _loadingService: LoadingService,
    private _formBuilder: FormBuilder,
    private _commercialService: CommercialService
  ) {}

  ngOnInit() {
    this.startDate = new Date();
    this.endDate = new Date();
    this.startDate.setYear(2008);

    this.makeAPaymentForm = this._formBuilder.group({
      paymentAmount: ["", Validators.required],
      creditCardSelect: ["", Validators.required],
    });
    this.makeAPaymentForm.controls["creditCardSelect"].setValue(null, {
      onlySelf: true,
    });

    this.commercialSubscription = this._commercialService
      .getCommercialValue()
      .subscribe((commercialVal) => {
        this.commercial = commercialVal;
      }
    )


    this.getProgramTypes()


    this.subscription = this._userService.getUser().subscribe(
      user => {
        this.user = user;

        if (user.customerIdArray) {

    this.subscription = this._userService.getUser().subscribe((user) => {
      this.user = user;

      if (user.customerIdArray) {
        if (user.customerIdArray.length > 0) {
          this._authGuard.getCreditCards();

          if (user.accountSummaryArray) {
            if (user.accountSummaryArray.length > 0) {
              this.getFees();
            }
          }
        }
        console.log(this.user)

        if(this.user.accountSummaryArray){
          if(this.user.accountSummaryArray.length > 0){
            this.isLoadingPaymentHistory = true;
            this.getPaymentHistory();
          }
        }

        if (user.creditCardArray) {
          if (user.creditCardArray.length > 0) {
            let defaultCard = null;
            for (var ccard of user.creditCardArray) {
              if (ccard.isPrimary) {
                defaultCard = ccard.id;
              }
            }
            this.makeAPaymentForm.controls[
              "creditCardSelect"
            ].setValue(defaultCard, { onlySelf: true });
          }
        }
      }
    });

    console.log(this.user);
      }
    })

    if(localStorage.getItem('isCustomerService008c084!1') && localStorage.getItem('isCustomerService008c084!1') == 'true'){
      this.isCustomerService = true;
    }

    this.referralCode = localStorage.getItem('referralCode') ? localStorage.getItem('referralCode'): undefined;

  }

  setUpPaymentHistoryData() {
    let accountId = ""
    if(this.user.accountSummaryArray.length > 0){
      accountId = this.user.accountSummaryArray[this.user.accountIndex].id
    } else {
      accountId = this.user.customerIdArray[this.user.customerIndex].Account.Id
    }
    return {
      CustomerId: this.user.customerIdArray[this.user.customerIndex].Id,
      AccountId: accountId,
      StartDate: this.startDate,
      EndDate: this.endDate,
    };
  }

  private buildPaymentHistory(data) {
    return data.map(e => {
      e.reference = e.authcode.split('|')[1];
      e.auth = e.authcode.split('|')[0];
      e.status = this.extractStatus(e.authcode);
      return e;
    });
  }

  private extractStatus(authcode) {
    let code = authcode.toLowerCase();
    if(code.includes('declined')) {
      return 'Declined';
    } else if (code.includes('voided')) {
      return 'Voided';
    } else if (code.includes('partially')){
      var tempSplit = authcode.split('|');
      var tempStr = ""
      tempSplit.forEach(element => {
        if(element.toString().includes('Partially')){
          tempStr = element.toString();
          return element.toString();
        }
      });
      return tempStr;
    }
    else if (code.includes('refunded')) {
      return 'Refunded';
    } else if (code.includes('approved')) {
      return 'Approved';
    } else {
      return 'N/A';
    }
  }


  getPaymentHistory() {
    
    const creditHistoryUrl = 'portfolios/PaymentHistory';
    let paymentResult: any;
    let data = this.setUpPaymentHistoryData();

    this._authGuard.authenticatedPost(creditHistoryUrl, data).subscribe(
      result => {
        this._userService.emptyPaymentHistoryArray();
        this.isLoadingPaymentHistory = false;
        console.log(result);
        paymentResult = result;
        this.paymentHistory = this.buildPaymentHistory(paymentResult);
      },
      error => console.log('Error: ' + error)
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onSubmit(form) {
    // Check user payments against default program replenishment rate to see if they've made the proper initial payment or not

    if (
      !this.makeAPaymentForm.value.paymentAmount ||
      0 === this.makeAPaymentForm.value.paymentAmount.length
    ) {
      let dialogRef = this.dialog.open(ResultDialogComponent, {
        data: {
          message: "Please enter a valid amount and try again.",
          alertType: "primary",
          title: "Payment Amount Required",
        },
      });
    }
    // allow payment amount of -9.99 through for testing purposes as requested.
    else if (
      this.makeAPaymentForm.value.paymentAmount !== -9.99 &&
      this.commercial.isCommercialDomain &&
      (this.makeAPaymentForm.value.paymentAmount <= 0 ||
        this.makeAPaymentForm.value.paymentAmount >= 10000)
    ) {
      console.log("payment failed");
      let dialogRef = this.dialog.open(ResultDialogComponent, {
        data: {
          message:
            "The payment amount must be greater than 0 and less than 10,000 dollars. Please enter a valid payment amount and try again",
          alertType: "primary",
          title: "Invalid Payment Amount",
        },
      });
    } 
    else if (this.makeAPaymentForm.value.paymentAmount !== -9.99 && 
      (this.makeAPaymentForm.value.paymentAmount <= 0 || this.makeAPaymentForm.value.paymentAmount >= 1000)) {
    console.log('payment failed');
    let dialogRef = this.dialog.open(ResultDialogComponent, {
      data: {
        message: 'The payment amount must be greater than 0 and less than 1,000 dollars. Please enter a valid payment amount and try again.',
        alertType: 'primary',
        title: 'Invalid Payment Amount'
      }
    });
  } else {
      console.log(this.user.accountSummaryArray[this.user.accountIndex])
      console.log(this.paymentHistory)
      if(this.user.accountSummaryArray[this.user.accountIndex] && this.paymentHistory && this.paymentHistory.length === 0){
        let userProgramTypeId = this.user.accountSummaryArray[this.user.accountIndex].ProgramType;
        this.programs.forEach(program => {
          if(program.Id == userProgramTypeId){
            console.log("Found program")
            this.defaultReplenishmentAmount = program.ReplenishmentAmount;
          }
        });
        //console.log(this.defaultReplenishmentAmount)
        if(this.defaultReplenishmentAmount){
          this.paymentHistory.forEach(payment => {
            if(payment.status == "Approved" && payment.amountpaid === this.defaultReplenishmentAmount){
              this.initialPaymentFound = true;
            }
          });
          //didn't find initital payment
          // console.log(this.paymentHistory) 
          // console.log(this.initialPaymentFound)
          // console.log(this.defaultReplenishmentAmount)
          // console.log(this.makeAPaymentForm.value.paymentAmount)
          if(!this.initialPaymentFound && this.makeAPaymentForm.value.paymentAmount < this.defaultReplenishmentAmount && !this.isCustomerService && this.paymentHistory.length === 0){
            let dialogRef = this.dialog.open(ResultDialogComponent, {
              data: {
                message: 'You must make an initial program payment of $' + String(this.defaultReplenishmentAmount) + '.',
                alertType: 'danger',
                title: 'Initial Program Payment Not Made'
              }
            });
            return
          }
        } else {
          if (!this.isCustomerService){
            let dialogRef = this.dialog.open(ResultDialogComponent, {
              data: {
                message: 'Could not find default program rate.',
                alertType: 'danger',
                title: 'Payment Rejected'
              }
            });
            return
          }
        }
      }

      if (this.isDisabled) {
        return false; //disable function if already clicked first time will work
      } else {
        this.isDisabled = true;
        let dataToSend = this.setUpSubmitPaymentData();

        this._loadingService.showLoader(); //show loader while processing payment

        this._authGuard
          .authenticatedPost(
            "portfolios/insertpayment",
            this.setUpSubmitPaymentData()
          )
          .subscribe(
            (result) => {
              console.log("insertPayment Return", result);
              this.receiptInfo = result;
              if (!this.receiptInfo.IsApproved) {
                let reason = this.receiptInfo.ResponseText.toLowerCase().includes(
                  "declined"
                )
                  ? ""
                  : "Reason: " + this.receiptInfo.ResponseText;
                let dialogRef = this.dialog.open(ResultDialogComponent, {
                  data: {
                    message:
                      "Please make sure your credit card information is up to date. " +
                      reason,
                    alertType: "danger",
                    title: "Payment Declined",
                  },
                });

                this._loadingService.hideLoader(); // hide loader, error
              } else {
                let name = this.user.customerIdArray[this.user.customerIndex]
                  .GeneralContact;

                this.isApproved = this.receiptInfo.IsApproved;
                this.receipt.amount = dataToSend.PaymentAmount.toLocaleString(
                  "en-US",
                  { style: "currency", currency: "USD" }
                );
                this.receipt.date = new Date().toString();
                this.receipt.referenceNumber = this.receiptInfo.RetrievalReferenceNumber;
                this.receipt.accountId = dataToSend.AccountId;
                this.receipt.transactionId = this.receiptInfo.TransactionNumber;
                this.receipt.cardNumber = this.receiptInfo.CardNumber;
                this.receipt.transactionType = this.receiptInfo.TransactionType;
                this.receipt.cardType = this.receiptInfo.CardType;
                this.receipt.responseMessage = this.receiptInfo.ResponseText;
                this.receipt.authCode = this.receiptInfo.AuthCode;
                this.receipt.avsResult = this.receiptInfo.AvsResult;

                this.dialog.open(ReceiptDialogComponent, {
                  data: {
                    payment_dt: this.receipt.date,
                    account_id: this.receipt.accountId,
                    amount: this.receipt.amount,
                    currency: this.receiptInfo.Currency,
                    id: this.receipt.transactionId,
                    username: name,
                    cardNumber: this.receipt.cardNumber.replace(/[Xx\s]/g, ""),
                    authCode: this.receipt.authCode,
                    reference: this.receipt.referenceNumber,
                    status: "Approved",
                  },
                  minWidth: this.initialModalWidth,
                });

                this._loadingService.hideLoader(); // hide loader on success

                this.getFees();
              }
              this.paymentSubmitted = true;
              this.makeAPaymentForm.get("paymentAmount").reset();
              this.isDisabled = false;
            },
            (error) => {
              console.log("Error: " + error);
              let dialogRef = this.dialog.open(ResultDialogComponent, {
                data: {
                  message: error,
                  alertType: "danger",
                  title: "Failed to submit payment",
                },
              });
              this._loadingService.hideLoader(); // hide loader on error
              this.receipt.responseMessage = error;
              this.isDisabled = false;
              this.paymentSubmitted = true;
            }
          );
      }
     }
  }

  setUpSubmitPaymentData() {
    console.log(this.makeAPaymentForm);
    if(this.referralCode) {
      return {
        AccountId: this.user.accountSummaryArray[0].id,
        CustomerId: this.user.customerIdArray[this.user.customerIndex].Id,
        Email: this.user.email.trim(),
        PaymentAmount: this.makeAPaymentForm.value.paymentAmount, // set this.feeTotal in prod, global denies duplicate payments
        CreditCardId: this.makeAPaymentForm.value.creditCardSelect
          ? this.makeAPaymentForm.value.creditCardSelect
          : 0,
        ReferralCode: this.referralCode
      };
    }
    return {
      AccountId: this.user.accountSummaryArray[0].id,
      CustomerId: this.user.customerIdArray[this.user.customerIndex].Id,
      Email: this.user.email.trim(),
      PaymentAmount: this.makeAPaymentForm.value.paymentAmount, // set this.feeTotal in prod, global denies duplicate payments
      CreditCardId: this.makeAPaymentForm.value.creditCardSelect
        ? this.makeAPaymentForm.value.creditCardSelect
        : 0,
    };
  }

  private getProgramTypes() {
    this._authGuard.authenticatedPost('portfolios/NexpressProgramTypes', { "IsCommercial": this.commercial.isCommercialDomain}).subscribe(
        result => {
            let programResult: any;
            programResult = result;
            this.programs = programResult.NexpressProgramTypes;
            console.log(this.programs);
        },
        error => console.log('get program types Error:', error)
    );
}

  getFees() {
    this._loadingService.showLoader(); // show loader on getFees
    this.isDisabled = true;
    this._authGuard
      .authenticatedPost("portfolios/FeeSummary", this.setUpFeesData())
      .subscribe(
        (result) => {
          let fees = 0;
          this.feeArray = result;
          for (let fee of this.feeArray) {
            fees += fee.feeamount;
          }
          this._loadingService.hideLoader(); // hide loader on success
          this.fees = this.formatMoney(fees);
          this.isDisabled = false;
        },
        (error) => {
          let dialogRef = this.dialog.open(ResultDialogComponent, {
            data: {
              message: error,
              alertType: "danger",
              title: "Failed to get fees",
            },
          });

          this._loadingService.hideLoader(); // hide loader on error
        }
      );
  }

  setUpFeesData() {
    return {
      CustomerId: this.user.customerIdArray[this.user.customerIndex].Id,
      AccountId: this.user.accountSummaryArray[this.user.accountIndex].id,
    };
  }

  onAccountChange(accountIndex) {
    this._userService.setAccountIndex(accountIndex);
    this.getFees();
  }

  formatMoney(value: number) {
    return value.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/make-payment/make-payment.component.ts